// @generated by scripts/generate-version.mjs — do not edit.
/**
 * The SDK package version ("@lizuz/sewa-sdk") reported to the host during
 * handshake via the "sdkVersion" field. Generated from "package.json" so it
 * can never drift from the published release.
 */
export const RPC_CLIENT_SDK_VERSION = "1.0.9";
